<!-- CNCT-6779: no e11-panel wrapper. It supplied a border, rounded-lg corners and an
     e11-mb-8 margin, which made the rail read as a card floating inside the sidebar
     rather than as the sidebar itself. -->
<div class="e11-w-full e11-h-full e11-px-3 e11-pt-4">
  <div class="e11-flex e11-flex-col e11-h-full e11-w-full">
    <e11-input
      [type]="'text'"
      [leadingIcon]="'search'"
      [formControl]="searchControl"
      name="settingsSearch"
      autocomplete="off"
      placeholder="{{ 'Search settings' | translate }}"
    ></e11-input>

    <nav class="e11-mt-4 e11-flex-1 e11-overflow-y-auto" [attr.aria-label]="'Settings' | translate">
      <ng-container *ngrxLet="vm$ as vm">
        <ng-container *ngrxLet="favorites$ as favorites">
          <ng-container *ngIf="vm.total > 0; else noResults">
            <div *ngFor="let group of vm.groups; trackBy: trackByGroup" class="e11-mb-4">
              <p class="e11-text-xs e11-uppercase e11-tracking-wide e11-text-skin-light e11-mb-1 e11-px-2">
                {{ group.group | translate }}
              </p>
              <ul class="e11-flex e11-flex-col">
                <li *ngFor="let category of group.categories; trackBy: trackByCategory">
                  <a
                    [routerLink]="[category.route]"
                    routerLinkActive="rail-row-active e11-bg-skin-primary-accent e11-text-skin-white"
                    class="rail-row e11-flex e11-items-center e11-gap-2 e11-px-2 e11-py-2 e11-rounded e11-cursor-pointer hover:e11-bg-skin-grey/10 e11-text-sm"
                    role="menuitem"
                    (click)="onSelect(category)"
                  >
                    <span class="material-symbols-outlined md-18">{{ category.icon }}</span>
                    <span class="e11-flex-1 e11-truncate">{{ category.label | translate }}</span>
                    <button
                      type="button"
                      class="rail-star e11-flex e11-items-center e11-justify-center e11-shrink-0 e11-w-[22px] e11-h-[22px] e11-rounded e11-cursor-pointer e11-bg-transparent e11-border-0 e11-p-0 focus-visible:e11-outline focus-visible:e11-outline-2 focus-visible:e11-outline-skin-primary-accent"
                      [class.rail-star-on]="isFavorite(favorites, category)"
                      [attr.aria-pressed]="isFavorite(favorites, category)"
                      [attr.aria-label]="(isFavorite(favorites, category) ? 'Remove from favorites' : 'Add to favorites') | translate"
                      [title]="(isFavorite(favorites, category) ? 'Remove from favorites' : 'Add to favorites') | translate"
                      (click)="onToggleFavorite($event, category)"
                    >
                      <span class="material-symbols-outlined md-18" [class.star-filled]="isFavorite(favorites, category)">star</span>
                    </button>
                  </a>
                </li>
              </ul>
            </div>
          </ng-container>
        </ng-container>
        <ng-template #noResults>
          <p class="e11-text-sm e11-text-skin-light e11-px-2 e11-py-4">{{ 'No settings match your search' | translate }}</p>
        </ng-template>
      </ng-container>
    </nav>
  </div>
</div>
